import React from 'react';

import { Text } from '../../../../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';

interface LoadingStateProps {
  progress: number; // 0-100
  message?: string;
}

export default function LoadingState({
  progress,
  message = 'Generating video thumbnails...',
}: LoadingStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center px-24"
      style={{
        backgroundColor: '#1A1C1E99',
        opacity: 60,
        backdropFilter: 'blur(80px)',
        width: '1078px',
        height: '100vh',
      }}
    >
      {/* Loading Content */}
      <div className="flex flex-col items-center gap-6">
        {/* Spinner */}
        <div className="w-12 h-12 border-4 border-yellow-400 border-t-transparent rounded-full animate-spin" />

        {/* Message */}
        <Text fontSize="lg" className="text-white text-center">
          {message}
        </Text>

        {/* Progress Bar */}
        <div className="w-96 bg-gray-700 rounded-full h-2">
          <div
            className="bg-yellow-400 h-2 rounded-full transition-all duration-300 ease-out"
            style={{ width: `${Math.max(0, Math.min(100, progress))}%` }}
          />
        </div>

        {/* Progress Text */}
        <Text fontSize="sm" className="text-gray-300">
          {Math.round(progress)}% complete
        </Text>
      </div>

      {/* Footer hint */}
      <div className="mt-12">
        <Text fontSize="sm" className="text-gray-400 text-center">
          This may take a few moments depending on video length
        </Text>
      </div>
    </div>
  );
}
